// extracted by mini-css-extract-plugin
export default {"container":"lba-z","heading":"mba-z","links":"nba-z","linkBtn":"oba-z","disabled":"pba-z","linkUppercaseBold":"qba-z","copy":"rba-z","subCopy":"sba-z"};